import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {
  OverdraftPaymentBreakupDialogData,
  OverdraftPaymentBreakupDialogData2,
  OverdraftPaymentBreakupDialogResult
} from '@portal-workspace/grow-shared-library';
import { CurrencyPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { GridModule } from '@angular/flex-layout/grid';
import { FlexModule } from '@angular/flex-layout/flex';
import {PercentagePipe} from "../../pipes/percentage.pipe";
import {ApplicationDialogService} from "./application-dialog.service";



@Component({
    templateUrl: './overdraft-payment-breakup.dialog.html',
    styleUrls: ['./overdraft-payment-breakup.dialog.scss'],
    standalone: true,
    imports: [
    FlexModule,
    GridModule,
    MatDividerModule,
    MatButtonModule,
    CurrencyPipe,
    MatDialogModule,
    PercentagePipe
]
})
export class OverdraftPaymentBreakupDialog implements OnInit {

  data: OverdraftPaymentBreakupDialogData| null = null;
  isQuote!: boolean;
  hideBrokerage!: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public opt: OverdraftPaymentBreakupDialogData2,
              private dialogRef: MatDialogRef<OverdraftPaymentBreakupDialog, OverdraftPaymentBreakupDialogResult>,
              private applicationDialogService: ApplicationDialogService) {
  }

  onAcceptQuotation($event: Event) {
    this.dialogRef.close({acceptedQuotation: true});
  }
  onClose($event: Event){
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.data = this.opt.loadFn();
    this.isQuote = this.opt.isQuote ?? false;
    this.hideBrokerage = !!this.opt.hideBrokerage;
  }

  onRateLogClick() {
    this.applicationDialogService.openInterestRateCalculationLogDialog({logs: this.data?.term?.calculationLog ?? []});
  }
}
